import { render, staticRenderFns } from "./ProjectsResale.vue?vue&type=template&id=7f8493b5&"
import script from "./ProjectsResale.vue?vue&type=script&lang=js&"
export * from "./ProjectsResale.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsResale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports